import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { dispatch } from '../store';

const initialState = {
  isInitializing: false,
  isLoading: false,
  error: null,
  creditInvestigators: [],
};

const slice = createSlice({
  name: 'internal-user-credit-investigators',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      if (!state.creditInvestigators || state.creditInvestigators.length === 0) {
        state.isInitializing = true;
      }
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.isInitializing = false;
    },

    getCreditInvestigatorsSuccess(state, action) {
      state.isLoading = false;
      state.creditInvestigators = action.payload;
      state.isInitializing = false;
    },
  },
});

export function getCreditInvestigators() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/internal/accounts/credit-investigators');
      dispatch(slice.actions.getCreditInvestigatorsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export default slice.reducer;
